import { render, staticRenderFns } from "./Cronometro.vue?vue&type=template&id=640695cf&"
import script from "./Cronometro.vue?vue&type=script&lang=js&"
export * from "./Cronometro.vue?vue&type=script&lang=js&"
import style0 from "./Cronometro.vue?vue&type=style&index=0&id=640695cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports